import { useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { BankSelectionBody } from '../../../BankSelectionModal/BankSelectionBody';
import { ChooseNewBankAccountVerification } from '../chooseNewBankAccountVerification/ChooseNewBankAccountVerification';
import { UploadBankStatementsForVerification } from '../uploadBankStatementsForVerification/UploadBankStatementsForVerification';

type TProps = {
    onClose: () => void;
    isModalOpen: boolean;
};
export type TNewBankAccountModalName =
    | null
    | 'open_banking'
    | 'manual_bs_upload';

export const VerifyNewBankAccountModal = ({ onClose, isModalOpen }: TProps) => {
    const [currentModal, setCurrentModal] =
        useState<TNewBankAccountModalName>(null);

    const updateModalStep = (step: TNewBankAccountModalName) => {
        setCurrentModal(step);
    };

    useEffect(() => {
        if (currentModal === 'open_banking') {
            tracking.ampli.addBankDetailsChooseLinkOpenBanking();
        } else if (currentModal === 'manual_bs_upload') {
            tracking.ampli.addBankDetailsChooseManualBsUpload();
        }
    }, [currentModal]);

    return (
        <Modal
            headerBar={true}
            onClose={() => {
                updateModalStep(null);
                onClose();
            }}
            isOpen={isModalOpen}
            closeIcon={true}
            data-testid="verify-new-bank-account-modal"
            title={<ModalTitle modalName={currentModal} />}
        >
            <ModalBody
                modalName={currentModal}
                onClose={() => {
                    onClose();
                }}
                updateModalStep={updateModalStep}
            />
        </Modal>
    );
};

const ModalTitle = ({ modalName }: { modalName: TNewBankAccountModalName }) => {
    switch (modalName) {
        case 'manual_bs_upload':
            return (
                <FormattedMessage
                    id="_.funding_requirements.add_payment_method.manual_bs_upload_verification.title"
                    defaultMessage="Upload a statement"
                />
            );
        case 'open_banking':
            return (
                <FormattedMessage
                    id="_.bank_selection_modal.verifiction_title"
                    defaultMessage="Link your business account"
                />
            );
        default:
            return (
                <FormattedMessage
                    id="_.funding_requirements.add_bank_details.choose_verification_method_title"
                    defaultMessage="How would you like to verify your account?"
                />
            );
    }
};

const ModalBody = ({
    modalName,
    updateModalStep,
    onClose
}: {
    modalName: TNewBankAccountModalName;
    onClose: () => void;
    updateModalStep: (nextStep: TNewBankAccountModalName) => void;
}) => {
    switch (modalName) {
        case 'manual_bs_upload':
            return (
                <UploadBankStatementsForVerification
                    changeVerificationMethod={updateModalStep}
                    onClose={onClose}
                />
            );
        case 'open_banking':
            return <BankSelectionBody linkingForBankVerification={true} />;
        default:
            return (
                <ChooseNewBankAccountVerification
                    changeVerificationMethod={updateModalStep}
                />
            );
    }
};
